<div [formGroup]="form" class="grid-1col input-grid-gaps">
    <div formArrayName="shifts">
        @for (shift of shiftsArray.controls; track $index; let i = $index) {
            <div class="flex gap-small pt-2">
                <input pInputText [formControlName]="i"/>
                <app-delete-button
                    [hideLabel]="true"
                    [confirmationType]="'none'"
                    (clickEvent)="removeShift(i)"
                ></app-delete-button>
            </div>
        }
    </div>
    <app-button icon="pi-plus" (clickEvent)="addShift()"></app-button>
</div>
